import type { StageMetrics } from '../../types.ts'
import { AgingDistribution } from './AgingDistribution.tsx'
import { ByFunnel } from './ByFunnel.tsx'
import { ByOwner } from './ByOwner.tsx'
import { ConversionMath } from './ConversionMath.tsx'

interface SidePanelProps {
  metrics: StageMetrics | null
  prevStageName: string | null
  nextStageName: string | null
  totalLeadsInStage: number
}

export function SidePanel({
  metrics,
  prevStageName,
  nextStageName,
  totalLeadsInStage,
}: SidePanelProps) {
  return (
    <aside className="flex w-72 shrink-0 flex-col gap-3 overflow-y-auto pl-3 @max-3xl/pip:hidden">
      <ConversionMath
        metrics={metrics}
        prevStageName={prevStageName}
        nextStageName={nextStageName}
      />
      <ByOwner totalLeadsInStage={totalLeadsInStage} />
      <ByFunnel totalLeadsInStage={totalLeadsInStage} />
      <AgingDistribution />
    </aside>
  )
}
